import { useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import { ClientReceiptService } from '@services/client_receipt.service'
import { ReceiptDto } from '../types/api'
import { TBookingStep } from '../types/general'
import { defaultQueryOptions } from './common'

export const useClientReceipt = (locationName: string, orderId: string, step: TBookingStep = 'CONFIRMATION') => {
  return useQuery<ReceiptDto, AxiosError<{ error: string }>>({
    queryKey: ['clientReceipt', locationName, orderId],
    queryFn: () => ClientReceiptService.getReceipt(locationName, orderId, step),
    enabled: !!locationName && !!orderId,
    ...defaultQueryOptions,
  })
}
